import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import HomePage from './HomePage';
import NotFound from './NotFound';
import AuctionPortal from './pages/AuctionPortal';
import OfflineAuctionPage from './pages/OfflineAuctionPage';
import OnlineAuctionPage from './pages/OnlineAuctionPage';
import SpectatorPage from './pages/SpectatorPage';

// Asta live e asta di riparazione condividono pagina e rotta: la modalita
// arriva dallo stato del server, non dall'URL.

export default function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/asta-offline" element={<OfflineAuctionPage />} />
                <Route path="/asta-online" element={<AuctionPortal />} />
                <Route path="/asta/:lobbyName" element={<OnlineAuctionPage />} />
                {/* Schermo da proiettare: stessa asta, in sola lettura. */}
                <Route path="/asta/:lobbyName/schermo" element={<SpectatorPage />} />

                {/* Vecchi percorsi, cosi i segnalibri non si rompono. */}
                <Route path="/auction" element={<Navigate to="/asta-online" replace />} />
                <Route path="/repair-auction" element={<Navigate to="/asta-online" replace />} />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}
